import Utils from '../../Utils';

export default class DedicatedSpace {

    static initializeEvents() {
        this.dynamicBackgroundImageHandler();
        window.addEventListener('scroll', this.dynamicBackgroundImageHandler);
    }

    static dynamicBackgroundImageHandler() {
        const dynamicBackgroundImage = document.querySelector('.dedicated-space-background-image');
        if (dynamicBackgroundImage) {
            const dynamicBackgroundImageTopPosition = Utils.getOffsetTop(dynamicBackgroundImage) - 56;
            if (window.scrollY >= dynamicBackgroundImageTopPosition) {
                if (!dynamicBackgroundImage.classList.contains('active')) {
                    dynamicBackgroundImage.classList.add('active');
                }

                dynamicBackgroundImage.style.backgroundPositionY = (window.scrollY - dynamicBackgroundImageTopPosition) + 'px';
            } else {
                if (dynamicBackgroundImage.classList.contains('active')) {
                    dynamicBackgroundImage.classList.remove('active');
                }

                if (dynamicBackgroundImage.style.backgroundPositionY !== '') {
                    dynamicBackgroundImage.style.backgroundPositionY = '';
                }
            }
        }
    }

}